function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import cn from "../../../utils/cn";
import PropTypes from 'prop-types';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BaseCardHeader = _ref => {
  let {
    children,
    className,
    id,
    title,
    noBorder = false,
    secondaryFullWidth = false
  } = _ref;
  const headerClass = cn({
    'bg-white rounded-t': true,
    'border-solid border-b border-medium-border-blue': !noBorder
  }, className);
  const mappedChildren = React.Children.map(children, (child, index) => /*#__PURE__*/_jsx("div", {
    className: cn({
      'flex-grow': secondaryFullWidth
    }, 'relative', 'flex-none', 'ml-3'),
    children: child
  }, index));
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread(_objectSpread({}, id ? {
    id
  } : {}), id ? {
    'data-testid': id
  } : {}), {}, {
    className: headerClass,
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex flex-row justify-between",
      children: [/*#__PURE__*/_jsx("h2", {
        className: "flex-auto p-4 pb-3",
        children: title
      }), /*#__PURE__*/_jsx("div", {
        className: "flex-auto py-2 pr-4 pl-0 flex flex-row justify-end items-center",
        children: mappedChildren
      })]
    })
  }));
};
BaseCardHeader.displayName = 'BaseCardHeader';
BaseCardHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
  title: PropTypes.string,
  noBorder: PropTypes.bool,
  secondaryFullWidth: PropTypes.bool
};
export default BaseCardHeader;
//# sourceMappingURL=BaseCardHeader.js.map